import type { AwsRdsComponents } from "@p0security/integrations-aws-rds-shared/components";
import { installTf } from "@p0security/integrations-aws-rds-shared/iac";
import {
  type FrontendInstaller,
  otherInstalledIntegration,
} from "@p0security/integrations-installer";

export type AwsRdsInstaller = FrontendInstaller<typeof AwsRdsComponents>;

const awsRdsIamWriteInstructions: AwsRdsInstaller["components"]["iam-write"]["instructions"] =
  (context, id) => {
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using
          Terraform:
        </>
      ),
      commands: {
        iac: [{ command: installTf(context, { vpcId: id }) }],
      },
    };
  };

export const awsRdsInstaller: AwsRdsInstaller = {
  components: {
    "iam-write": {
      items: {
        accountId: {
          optionProvider: otherInstalledIntegration({
            integration: "aws",
            component: "iam-write",
          }),
        },
      },
      instructions: awsRdsIamWriteInstructions,
    },
  },
};
